'use strict';
//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
//**** cn_space_dummy : a space without geometry (except a position)
//***********************************************************************************
//***********************************************************************************

import { cn_element } from './cn_element';
import { cnx_add, cnx_clone, cnx_dist, cnx_normalize, cnx_sub, cn_add, cn_box, cn_cart, cn_clone, cn_dist, cn_mul, cn_normalize, cn_polar, cn_sub } from '../utils/cn_utilities';
import { cn_pastille } from '../svg/cn_pastille';
import { fh_add, fh_cross, fh_dot, fh_mul, fh_normalize } from '@acenv/fh-3d-viewer';
import { cn_image_dir } from '../utils/image_dir';
import { logger } from '../utils/cn_logger';
import { cn_camera } from '../svg/cn_camera';
import { cn_plugin_option } from '../utils/cn_plugin_option';
import { SPACE_EXTERIOR_LABEL } from './cn_model_constants';

export class cn_space_dummy extends cn_element {
    constructor(parent) {
        super(parent);
        this.class_name = 'cn_space_dummy';

        this.name = "";
        this.index = -1;
        this.label_position = [0, 0];
        this.space_type = null; 

        this.parent_space = null;
        
        this.screen_bounding_box = new cn_box();
        this.label_end = [0,0];
    }
    
    //***********************************************************************************
    //**** serialize
    //***********************************************************************************
    serialize() {
        var json = this.serialize_element();
        json.name = this.name;
        json.index = this.index;
        json.label_position = this.label_position;
        json.space_type = this.space_type ? this.space_type.ID : null;
        return json;
    }

    static unserialize(json, scene) {
        var space = new cn_space_dummy(scene);
        space.unserialize_element(json);
        
        if (typeof (json.name) == 'number')
            space.name = json.name;

        if (typeof (json.index) == 'number')
            space.index = json.index;
        
        if (typeof (json.label_position) == 'object')
            space.label_position = json.label_position;

        if (json.space_type) {
            space.space_type = scene.building.get_element_type(json.space_type);
        }
        
        scene.space_dummies.push(space);
        return space;
    }

    /**
     * Returns the base name of the space (before any numerotation)
     * @returns {string}
     */
    get_base_name() {
        if (this.name != "") 
            return this.name;
        if (this.space_type && this.space_type.space_default_name != "") 
            return this.space_type.space_default_name;
        return cn_plugin_option.default_space_label;
    }

    /**
     * Returns the storey numerotation of the space
     * @returns {string}
     */
    get_storey_name(storey) {
        if (storey.exterior === true)
            return SPACE_EXTERIOR_LABEL.toLocaleLowerCase();
        return "" + storey.storey_index;
    }

    /**
     * Returns the full name of the space
     * @returns {string}
     */
    get_name(storey) {
        let name = this.get_base_name();

        let other_spaces = storey.scene.space_dummies.filter(s => s.get_base_name() == name);
        if (other_spaces.length == 1) return name;

        other_spaces.sort((a,b) => a.index - b.index);
        return `${name} ${this.get_storey_name(storey)}.${1+other_spaces.indexOf(this)}`;
    }

    draw(camera, add_classes = []) {
        let html = "";

        if (add_classes.includes("mouseover") || add_classes.includes("selected"))
            html+= `<rect style="fill:black; opacity: 0.1;" x="${this.screen_bounding_box.posmin[0]}" y="${this.screen_bounding_box.posmin[1]}" width="${this.screen_bounding_box.size[0]}"  height="${this.screen_bounding_box.size[1]}" />`

        return html;
    }
    get_children_spaces() {
        return [];
    }

    get_bounding_box() {
        let box = new cn_box();
        box.enlarge_point(this.label_position);
        box.enlarge_point(this.label_end);
        return box;
    }

    get_screen_bounding_box() {
        return this.screen_bounding_box;
    }

    contains(p, precision) {
        let box = this.get_bounding_box();
        return box.contains_point(p);
    }
}

